import React, { useState, useEffect } from 'react';
import img1 from '../Components/Images/mobilesecurity/1.png'
import img2 from '../Components/Images/mobilesecurity/2.png'
import img3 from '../Components/Images/mobilesecurity/3.png'
import img4 from '../Components/Images/mobilesecurity/4.png'
import img5 from '../Components/Images/mobilesecurity/5.png'
import img6 from '../Components/Images/mobilesecurity/6.png'
import img7 from '../Components/Images/mobilesecurity/7.png'
import img8 from '../Components/Images/mobilesecurity/8.png'
import img9 from '../Components/Images/mobilesecurity/9.png'



const ProductCatalogMobile = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);

  const categories = [
    { id: 'all', name: 'All Products', icon: 'fas fa-th-large' },
    { id: 'mobile', name: 'Mobile & Tablet', icon: 'fas fa-mobile-alt' },
    { id: 'recoiler', name: 'Recoiler Stands', icon: 'fas fa-link' },
    { id: 'sensor', name: 'Sensor Systems', icon: 'fas fa-wifi' },
    { id: 'accessories', name: 'Accessories', icon: 'fas fa-headphones' },
    { id: 'specialty', name: 'Specialty Items', icon: 'fas fa-tools' }
  ];

  const products = [
   
    
    // Recoiler Stands
    {
      id: 'rs001',
      name: 'RS001 Recoiler Stand',
      category: 'recoiler',
      type: 'Security Stand',
      description: 'Recoiler stand with retractable 3.2mm steel wire',
      features: ['Retractable 3.2mm steel wire', 'Lockdown function both sides', 'Locked charging cable', 'Under table screw mount option'],
      image: img1
    },
   
    
    {
      id: 'rs001-t',
      name: 'RS001-T Tablet Stand',
      category: 'recoiler',
      type: 'Tablet Stand',
      description: 'Specialized recoiler stand designed for tablets',
      features: ['Tablet-specific design', 'Adjustable viewing angle', 'Secure mounting', 'Cable management'],
      image: img2
    },
  
    // Sensor Systems
    
    // MS Series
    {
      id: 'ms-vertical-001',
      name: 'MS-Vertical-001',
      category: 'mobile',
      type: 'Vertical Stand',
      description: 'White vertical stand with 100dB alarm, supports tablet, earphone, cellphone',
      features: ['100dB alarm volume', 'Tablet support', 'Earphone compatibility', 'Cellphone mounting', 'White finish (Black customizable)'],
      image: img3
    },
    {
      id: 'ms001',
      name: 'MS001 Flat Stand',
      category: 'mobile',
      type: 'Display Stand',
      description: '38CM height, 2 port connectors, flat stand for wall mount display',
      features: ['38CM height', '2 port connectors', 'Wall mount compatible', 'Locked sensor cable with LED', 'Second port for accessory protection'],
      image: img4
    },

    
    // MC Series
    {
      id: 'mc020-1',
      name: 'MC020-1 Mini Standalone',
      category: 'sensor',
      type: 'Mini System',
      description: 'Mini 2 port standalone security system',
      features: ['2 port configuration', 'Standalone operation', 'Compact design', 'Independent functionality'],
      image: img5
    },
    
    // Accessories
    {
      id: 'mh001',
      name: 'MH001 Headphone Stand',
      category: 'accessories',
      type: 'Headphone Stand',
      description: 'Headphone stand supporting earphone, headset display with charging capability',
      features: ['Earphone support', 'Headset display', 'Charging with micro/USB-C', 'Universal compatibility'],
      image: img6
    },
    {
      id: 'mw001',
      name: 'MW001 Watch Stand',
      category: 'accessories',
      type: 'Watch Stand',
      description: 'Watch stand supporting watch band and body protection',
      features: ['Watch band support', 'Body protection', 'Secure mounting', 'Display optimization'],
      image: img7
    },
    {
      id: 'mc001',
      name: 'MC001 Camera Stand',
      category: 'accessories',
      type: 'Camera Stand',
      description: 'Camera stand holder supporting lens display',
      features: ['Camera support', 'Lens display', 'Secure mounting', 'Professional presentation'],
      image: img8
    },
    {
      id: 'mv001',
      name: 'MV001 Shaver Stand',
      category: 'specialty',
      type: 'Shaver Stand',
      description: '38MM height, 2 port connectors, flat stand for wall mount display',
      features: ['38MM height', '2 port connectors', 'Wall mount compatible', 'Specialized for shavers'],
      image: img9
    },
    

    // Tools & Controllers
    
  ];

  // useEffect(() => {
  //   let filtered = products;

  //   if (activeCategory !== 'all') {
  //     filtered = filtered.filter(product => product.category === activeCategory);
  //   }

  //   if (searchTerm) {
  //     filtered = filtered.filter(product =>
  //       product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       product.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       product.type.toLowerCase().includes(searchTerm.toLowerCase())
  //     );
  //   }

  //   setFilteredProducts(filtered);
  // }, [activeCategory, searchTerm]);

  return (
    <div className="products-catalog">
      <style jsx>{`
        .products-catalog {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          background: radial-gradient(rgb(50, 52, 48), rgb(72, 76, 68), rgb(50, 52, 48));
          min-height: 100vh;
        }

        .hero-header {
          background: rgba(0,0,0,0.2);
          backdrop-filter: blur(10px);
          padding: 60px 0;
          text-align: center;
          color: white;
        }

        .category-filter {
          background: white;
          border-radius: 15px;
          padding: 2rem;
          margin: -30px 0 50px 0;
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
        }

        .category-btn {
          background: #f8f9fa;
          border: 2px solid transparent;
          border-radius: 12px;
          padding: 15px 25px;
          margin: 5px;
          transition: all 0.3s ease;
          color: #495057;
          font-weight: 500;
        }

        .category-btn:hover {
          background: #e9ecef;
          transform: translateY(-2px);
        }

        .category-btn.active {
          background: linear-gradient(45deg, #667eea, #764ba2);
          color: white;
          border-color: #667eea;
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
        }

        .search-box {
          border: 2px solid #e9ecef;
          border-radius: 12px;
          padding: 15px 20px;
          font-size: 1.1rem;
          transition: all 0.3s ease;
        }

        .search-box:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .product-card {
          background: white;
          border-radius: 20px;
          padding: 2rem;
          margin-bottom: 0rem;
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
          border: none;
          height: 100%;
        }

        .product-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 25px 50px rgba(0,0,0,0.15);
        }

        .product-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(45deg, #667eea, #764ba2);
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          color: white;
          margin-bottom: 1.5rem;
        }

        .product-category {
          background: linear-gradient(45deg, #ff6b6b, #ee5a24);
          color: white;
          padding: 5px 15px;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          display: inline-block;
          margin-bottom: 1rem;
        }

        .product-title {
          font-size: 1.4rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
          color: #2d3748;
        }

        .product-type {
          color: #718096;
          font-size: 0.9rem;
          margin-bottom: 1rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .product-description {
          color: #4a5568;
          margin-bottom: 1.5rem;
          line-height: 1.6;
        }

        .feature-list {
          list-style: none;
          padding: 0;
          line-height: 60%;
        }

        .feature-list li {
          
          color: #718096;
          font-size: 0.9rem;
          position: relative;
          padding-left: 20px;
        }

        .feature-list li:before {
          content: '✓';
          position: absolute;
          left: 0;
          color: #48bb78;
          font-weight: bold;
        }

        .stats-section {
          background: rgba(255,255,255,0.1);
          backdrop-filter: blur(10px);
          border-radius: 15px;
          padding: 2rem;
          margin: 3rem 0;
          color: white;
        }

        .stat-item {
          text-align: center;
        }

        .stat-number {
          font-size: 3rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
        }

        .stat-label {
          font-size: 1.1rem;
          opacity: 0.9;
        }

        @media (max-width: 768px) {
          .category-btn {
            width: 100%;
            margin: 5px 0;
          }
          
          .product-card {
            margin-bottom: 1.5rem;
          }
        }
      `}</style>

      {/* Hero Header */}
      <div className="hero-header">
        <div className="container">
          <h1 className="display-6 fw-bold mb-0">Product Catalog</h1>
          <p className="lead mb-0">Comprehensive Security Solutions for Electronic Devices</p>
        </div>
      </div>

      <div className="container">
        {/* Category Filter & Search */}
        {/* <div className="category-filter">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="d-flex flex-wrap justify-content-center justify-content-lg-start">
                {categories.map(category => (
                  <button
                    key={category.id}
                    className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
                    onClick={() => setActiveCategory(category.id)}
                  >
                    <i className={`${category.icon} me-2`}></i>
                    {category.name}
                  </button>
                ))}
              </div>
            </div>
            <div className="col-lg-4">
              <div className="input-group">
                <span className="input-group-text bg-light border-0">
                  <i className="fas fa-search text-muted"></i>
                </span>
                <input
                  type="text"
                  className="form-control search-box border-start-0"
                  placeholder="Search products..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div> */}

        {/* Stats Section */}
        {/* <div className="stats-section">
          <div className="row">
            <div className="col-md-3">
              <div className="stat-item">
                <div className="stat-number">{products.length}</div>
                <div className="stat-label">Total Products</div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stat-item">
                <div className="stat-number">{categories.length - 1}</div>
                <div className="stat-label">Categories</div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stat-item">
                <div className="stat-number">{filteredProducts.length}</div>
                <div className="stat-label">Showing</div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="stat-item">
                <div className="stat-number">100%</div>
                <div className="stat-label">Secure</div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Products Grid */}
        <div className="row mt-5">
          {/* {filteredProducts.length === 0 ? (
            <div className="col-12 text-center text-white">
              <i className="fas fa-search fa-3x mb-3 opacity-50"></i>
              <h3>No products found</h3>
              <p>Try adjusting your search or category filter</p>
            </div>
          ) : ( */}
            {products.map(product => (
              <div key={product.id} className="col-lg-4 col-md-6 mb-3">
                <div className="product-card">
                  <div className="align-items-center justify-content-center">
                    <img src={product.image} className='object-fit-contain w-100'></img>
                  </div>
                  
                  {/* <div className="product-category">
                    {categories.find(cat => cat.id === product.category)?.name || 'Product'}
                  </div> */}
                  
                  <h3 className="product-title">{product.name}</h3>
                  <div className="product-type">{product.type}</div>
                  
                  <p className="product-description">{product.description}</p>
                  
                  <div className="features">
                    <h6 className="fw-semibold ">Key Features:</h6>
                    <ul className="feature-list">
                      {product.features.slice(0, 4).map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))
          }
        </div>

        {/* Contact Section */}
        {/* <div className="text-center py-5">
          <div className="stats-section">
            <h3 className="mb-3">Need More Information?</h3>
            <p className="mb-4">Contact us for detailed specifications and custom solutions</p>
            <div className="row justify-content-center">
              <div className="col-auto">
                <div className="d-flex align-items-center mb-2">
                  <i className="fas fa-envelope me-2"></i>
                  <span>Sales@showguard.cn</span>
                </div>
              </div>
              <div className="col-auto">
                <div className="d-flex align-items-center mb-2">
                  <i className="fas fa-phone me-2"></i>
                  <span>+86 18367104111</span>
                </div>
              </div>
              <div className="col-auto">
                <div className="d-flex align-items-center mb-2">
                  <i className="fas fa-globe me-2"></i>
                  <span>www.showsafeplay.com</span>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>

      {/* Font Awesome CDN */}
      <link 
        rel="stylesheet" 
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" 
      />
    </div>
  );
};

export default ProductCatalogMobile;